import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e566bf78"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  role: "list",
  "aria-label": "즐겨찾는 노선 목록"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-row" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    ($setup.orderedFavoriteLines.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("ul", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.orderedFavoriteLines, (line) => {
              return (_openBlock(), _createElementBlock("li", {
                key: $setup.getFavoriteLineKey(line),
                role: "listitem"
              }, [
                _createVNode($setup["FavoriteLineRow"], {
                  favoriteLine: line,
                  onOnClickFavoriteStatusButton: ($event: any) => ($setup.emitOnClickFavoriteStatusButton(line)),
                  onOnClickBoardingStatusButton: ($event: any) => (
              $setup.emitOnClickFavoriteBoardingButton(line)
            ),
                  role: "link",
                  tabindex: "0",
                  onClick: _withModifiers(($event: any) => ($setup.goToLineInfoDetail(line)), ["prevent"]),
                  onKeydown: _withKeys(_withModifiers(($event: any) => ($setup.goToLineInfoDetail(line)), ["prevent"]), ["enter"]),
                  "aria-label": `${$setup.useGetLineRouteName(
              line.lineTypeCode,
              line.routeName,
              line.lineNum
            )} 노선 상세 화면으로 이동`
                }, null, 8 /* PROPS */, ["favoriteLine", "onOnClickFavoriteStatusButton", "onOnClickBoardingStatusButton", "onClick", "onKeydown", "aria-label"])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _createElementVNode("button", {
            class: "search-btn",
            type: "button",
            onClick: $setup.goToSearch,
            "aria-label": "다른 노선 검색하기"
          }, [
            _createVNode($setup["InlineSvg"], {
              class: "search-icon",
              src: require('@/assets/icons/search-bold.svg'),
              "aria-hidden": "true",
              alt: ""
            }, null, 8 /* PROPS */, ["src"]),
            _createTextVNode(" 다른 노선 검색하기 ")
          ]),
          _createCommentVNode(" 하단 버튼에 마지막 즐겨찾기 Item의 [즐겨찾기 버튼]이 가려지는 문제 방지 "),
          _hoisted_2
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createBlock($setup["NoFavoriteCard"], {
          key: 1,
          onOnClickSearch: $setup.goToSearch,
          shouldHideBorder: true
        }))
  ]))
}